import React from 'react';

import EditColumnsButton from '../index';
import { EditCustomersColumnsModalContainer } from '../../../containers/edit-customers-columns-modal-container';
import { useModal } from '../../../hooks/use-modal';

const EditCustomerGridColumnsButton = () => {
  const { close, isOpen, open } = useModal();

  return (
    <React.Fragment>
      <EditColumnsButton onClick={open} />
      {isOpen && <EditCustomersColumnsModalContainer onClose={close} />}
    </React.Fragment>
  );
};

export default EditCustomerGridColumnsButton;
